/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 */
import { api } from '../../../config/api';

import type { UpdateOnboardingBookingRulesApiArg, UpdateOnboardingDraftResponse } from '../types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    updateOnboardingBookingRules: build.mutation<UpdateOnboardingDraftResponse, UpdateOnboardingBookingRulesApiArg>({
      query: (queryArg) => ({
        body: queryArg.body,
        method: 'PATCH',
        url: `/v1/onboarding/booking-rules`,
      }),
    }),
  }),
  overrideExisting: true,
});

export { injectedRtkApi as updateOnboardingBookingRulesApi };
export const { useUpdateOnboardingBookingRulesMutation } = injectedRtkApi;
